import React from 'react'
import {
  Alert,
  AlertIcon,
  AlertDescription,
  Link,
  Text
} from '@chakra-ui/react'
import { useTranslations } from 'next-intl'
import { PaymentStatus } from '@/types/payments.interface'
import router from 'next/router'


type PaymentStatusAlertProps = {
  status: PaymentStatus
  txId?: string
  backToInvoices?: boolean
}

export const PaymentStatusAlert = ({
  status,
  txId,
  backToInvoices = true,
}: PaymentStatusAlertProps) => {
  const t = useTranslations('checkout.crypto-landing-page')
  const isInvoice = router.pathname.includes('invoice')

  const backToUrl = isInvoice
    ? '/dashboard/billing?tab=invoices'
    : '/dashboard/billing?tab=orders'

  if (status === 'PAID') {
    const txHref = `https://mempool.space/tx/${txId}`

    return (
      <Alert
        status="info"
        bg="blue.50"
        mt={{ base: 3, md: 6 }}
      >
        <AlertIcon color="blue.500" />
        <AlertDescription>
          <Text color="gray.700">
            {t.rich('transaction-confirmed', {
              txn: (children) =>
                txHref ? (
                  <Link
                    href={txHref}
                    color="gray.700"
                    textDecoration="underline"
                    isExternal
                  >
                    {children}
                  </Link>
                ) : (
                  <>{children}</>
                ),
            })}
            {` `}
            <Link
              href={backToUrl}
              color="gray.700"
              textDecoration="underline"
              textTransform="lowercase"
            >
              {isInvoice
                ? t('back-to-invoices')
                : t('back-to-orders')
              }
            </Link>
          </Text>
        </AlertDescription>
      </Alert>
    )
  }

  if (status === 'IN_PROCESS') {
    return (
      <Alert status="warning" bg="orange.50" mt={{ base: 3, md: 6 }}>
        <AlertIcon color="orange.500" />
        <AlertDescription>
          <Text color="gray.700">
            {t('payment-detected')}
              {backToInvoices && (
                <>
                  {' '}
                  {t.rich('view-status', {
                    link: (children) => (
                      <Link
                        href="/dashboard/billing?tab=invoices"
                        color="gray.700"
                        textDecoration="underline"
                      >
                        {children}
                      </Link>
                    ),
                  })}
                </>
              )}
          </Text>
        </AlertDescription>
      </Alert>
    )
  }

  return null
}

export default PaymentStatusAlert
